var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{class:{'custom-color':_vm.color,'icon-medium':_setup.compMedium,'icon-small':_setup.compSmall,'icon-xsmall':_setup.compXSmall},attrs:{"small":_setup.compSmall,"large":_setup.compLarge,"xLarge":_setup.compXLarge,"color":_vm.color}},[_vm._v(_vm._s(_setup.compIcon))])
}
var staticRenderFns = []

export { render, staticRenderFns }